<template>
  <q-chip
    clickable
    square
    :color="color"
    :text-color="textColor"
    :label="payment.disputedState ? $_.startCase(payment.disputedState) : '<unknown>'"
  />
</template>

<script>

export default {
  name: 'OrderStateCell',
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  computed: {
    payment () {
      return this.props.row
    },
    color () {
      if (this.payment.disputedState === 'won') {
        return 'green-3'
      } else if (this.payment.disputedState === 'needs_response' || this.payment.disputedState === 'warning_needs_response' || this.payment.disputedState === 'warning_closed') {
        return 'negative'
      } else if (this.payment.disputedState === 'lost') {
        return 'red-3'
      } else {
        return null
      }
    },
    textColor () {
      if (this.payment.disputedState === 'won') {
        return 'white'
      } else if (this.payment.disputedState === 'needs_response' || this.payment.disputedState === 'warning_needs_response' || this.payment.disputedState === 'warning_closed') {
        return 'white'
      } else if (this.payment.disputedState === 'lost') {
        return 'white'
      } else if (this.payment.disputedState === 'under_review') {
        return 'grey-6'
      } else {
        return 'dark'
      }
    }
  }
}

</script>
